import { themeConWeb } from '@app/util/modernThemeConweb'
import { Box, Button, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import currency from 'currency.js'
import React, { useEffect, useState } from 'react'

import { useMyReferralWithEnabledDetails } from '../../hooks/referral'
import { copyToClipboard } from '../../util/formatUtils'

const useStyles = makeStyles({
  button: {
    width: 200,
  },
  buttonSuccess: {
    '&:hover': {
      backgroundColor: themeConWeb.color.success,
    },
    backgroundColor: themeConWeb.color.success,
  },
})

const ButtonCopy = ({ clipboardText }) => {
  const classes = useStyles()
  const [copied, setCopied] = useState(false)

  const handleClick = () => {
    setCopied(true)
    copyToClipboard(clipboardText)
  }

  useEffect(() => {
    if (copied) {
      const clearCopied = setTimeout(() => setCopied(false), 5000)

      return () => {
        clearTimeout(clearCopied)
      }
    }
  }, [copied])

  return (
    <Button
      className={`${classes.button} ${copied && classes.buttonSuccess}`}
      color="primary"
      fullWidth
      onClick={handleClick}
      variant="contained"
    >
      {copied ? 'Copied!' : 'Copy referral link'}
    </Button>
  )
}

const HomeReferral = () => {
  const { referralAndEnabledDetails } = useMyReferralWithEnabledDetails()
  const clipboardText = `Have you tried Foodsby? Sign up with my link and you will get ${currency(
    referralAndEnabledDetails?.referralEnabledDetails?.rewardAmountPennies / 100,
    { formatWithSymbol: true },
  ).format()} off your first order: ${referralAndEnabledDetails?.referral?.shareUrl}`

  return (
    <Box paddingRight={4}>
      <img
        alt=""
        className="-image"
        src={`${process.env.REACT_APP_BASE_ORDER_URL}/images/home-referral.png`}
        width="220"
      />
      <Box marginY={2}>
        <Typography variant="h6">Give $5, Get $5</Typography>
        <Typography component="p" gutterBottom variant="body1">
          Refer your friends and co-workers and you’ll each get $5 when they place their first
          order.
        </Typography>
      </Box>
      <ButtonCopy clipboardText={clipboardText} />
    </Box>
  )
}

export default HomeReferral
